<template>
  <div class="main-wrapper">
    <headerfour></headerfour>
    <sidebar-four></sidebar-four>

    <!-- Page Wrapper -->
    <div class="page-wrapper-three">
      <div class="content container-fluid">
        <indexpage></indexpage>
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
</template>
